// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__YXrWd","modal":"Modal_modal__F1V9e","slide-down":"Modal_slide-down__zJVO8"};